import React from "react";
import styled from "styled-components";
import { r } from "../../utils";

const Flex = styled.div`
  position: relative;
  flex-direction: ${({ direction }) => direction || "row"};
  align-items: ${({ align }) => align || "center"};
  display: flex;
  justify-content: ${({ justify }) => justify || "space-between"};
`;

export const HFlexFlipper = Flex.extend`
  ${r("flex-direction", "row", "column")};
`;
export const VFlexFlipper = Flex.extend`
  ${r("flex-direction", "column", "row")};
`;
export default Flex;



// WEBPACK FOOTER //
// ./src/components/blocks/Flex.js